import { useMemo, useState } from 'react';
import cs from 'classnames';
import { useAtomValue } from 'jotai';
import { Drawer } from '../drawer';
import { useTranslation } from 'react-i18next';
import Link from 'icon/link_fill.svg';
import ArrowTriangleDownFill from 'icon/arrow_triangle_down_fill.svg';
import InsIcon from 'icon/logo_instagram.svg';
import TwitterIcon from 'icon/logo_twitter.svg';
import YoutubeIcon from 'icon/logo_youtube.svg';
import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { IUserDetail } from 'shared/models';

import './user-link.scss';

interface UserLinksProps {
  user: IUserDetail;
}

// link order
// const linkType = ['ins', 'twitter', 'youtube', 'personal'];

export function UserLinks(props: UserLinksProps): JSX.Element {
  const { user } = props;
  const { thirdLinks } = user;
  const isMultipleLink = thirdLinks.length > 1;

  const { isMobile } = useAtomValue($UserAgent);
  const isPC = !isMobile;

  const { t } = useTranslation();

  const [pressIndex, setPressIndex] = useState(-1);
  const [showActionsheet, setShowActionsheet] = useState(false);

  const actionSheetItemTouchStart = (index: number) => {
    setPressIndex(index);
  };
  const actionSheetItemTouchEnd = (_: number) => {
    setPressIndex(-1);
  };

  const closeLinkModal = () => {
    setShowActionsheet(false);
  };

  const handleLinkClick = () => {
    if (isMultipleLink) {
      setShowActionsheet(true);
    } else {
      location.href = thirdLinks[0].url;
    }
  };

  const Icon = useMemo(() => {
    const platform = thirdLinks[0].platform;
    if (platform === 'personal') {
      return Link;
    } else if (platform === 'ins') {
      return InsIcon;
    } else if (platform === 'twitter') {
      return TwitterIcon;
    } else {
      return YoutubeIcon;
    }
  }, [thirdLinks]);

  if (thirdLinks.length > 0) {
    return (
      <div className="user-introduction-link">
        <div className="user-introduction-link-content" onClick={handleLinkClick}>
          <Icon className={cs('user-introduction-link-icon', thirdLinks[0].platform)} />
          <p>{thirdLinks[0].name}</p>
          {isMultipleLink && <ArrowTriangleDownFill className="user-introduction-link-arrow" />}
        </div>
        <Drawer isOpen={showActionsheet} key="links" onClose={closeLinkModal} className={cs({ isPC })}>
          {
            <div className="user-introduction-link-actionsheet" onClick={closeLinkModal}>
              <div className="user-introduction-link-actionsheet-content">
                <div className="action-sheet">
                  {thirdLinks.map((item, index) => {
                    return (
                      <div
                        key={`link-${item}-${index}`}
                        className={cs('action-sheet-item', item.platform, {
                          'action-sheet-item-last': index === thirdLinks.length,
                        })}
                        onClick={() => {
                          window.open(item.url, '_blank');
                        }}
                        onTouchStart={() => {
                          actionSheetItemTouchStart(index);
                        }}
                        onTouchEnd={() => {
                          actionSheetItemTouchEnd(index);
                        }}
                      >
                        {pressIndex === index && <div className="action-sheet-item-mask" />}
                        {item.platform === 'personal' ? (
                          <Link className="action-sheet-icon" />
                        ) : (
                          <div className="action-sheet-icon" />
                        )}
                        <p>{item.name}</p>
                      </div>
                    );
                  })}
                </div>
                <div className="close" onClick={closeLinkModal}>
                  {t('cancel_picture_view')}
                </div>
              </div>
            </div>
          }
        </Drawer>
      </div>
    );
  }

  return <></>;
}
